import { ActionHandler } from "../../../common/actions/core/action-handler";
import { Action } from "../../../common/actions/core/action";
import { UserResponse } from "../../../common/services/user/user.model";
import GlobalSpinnerService from "../../../common/services/spinner/global-spinner.service";
import UserService from "../../../common/services/user/user.service";
import ActionDispatcherService from "../../../common/actions/core/action-dispatcher.service";
import {OpenStudentRejectedAction} from "./rejected.action";
import { OpenStudentNoSubAction } from "../nosub/nosub.action";

/*@ngInject*/
export default class OpenStudentRejectedController implements ActionHandler{
  protected user: UserResponse;
  protected dialogElement;

  constructor(
    protected $element,
    protected actionDispatcher: ActionDispatcherService,
    protected globalSpinner: GlobalSpinnerService,
    protected userService: UserService
  ) {
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#student-plan-application-reject-modal').remodal();
    this.actionDispatcher.register(this);
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }
  public handle(action: Action) {
    if (action instanceof OpenStudentRejectedAction) {
      this.handleDialogAction(action);
    }
  }

  protected handleDialogAction(action: OpenStudentRejectedAction) {
    this.globalSpinner.start();
    this.userService.getUserInfo()
      .then(data => {
        this.user = data;
        this.openDialog();
      })
      .finally(() => {
        this.globalSpinner.stop();
      });
  }

  public onCancel() {
    this.close();
  }

  public openApply(){
    this.actionDispatcher.dispatch(
      new OpenStudentNoSubAction()
    );
  }

  private openDialog() {
    this.dialogElement.open();
  }

  private close() {
    this.dialogElement.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/student/rejected/rejected.controller.ts